<template>
  <li>
    <input type="radio"
           v-bind:disabled="disabled"
           v-bind:id="'answer-' + index"
           v-bind:checked="answer.checked || answer.correct"
           @click="select">
    <label v-bind:for="'answer-' + index" v-html="answer.content"></label>
  </li>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  name: "Answer",
  props: {
    answer: Object,
    index: Number
  },
  computed: {
    ...mapGetters(["currentQuestionResult", "quizPassed"]),
    ...mapState(["isStudyGuide"]),
    disabled() {
      return (
        !!this.currentQuestionResult || (this.isStudyGuide && this.quizPassed)
      );
    }
  },
  methods: {
    ...mapActions(["setAnswer"]),
    select() {
      this.setAnswer(this.answer.id);
    }
  }
};
</script>
